// $('.domain-search-form').submit(function(e) {
//     e.preventDefault();
//     $('.domain-search-results').show();
//     $('.domains-order').show();
//     $('.domain-search-empty').hide();
// });
const domainSearchForm = document.querySelector('.domain-search-form')
const searchResults = document.querySelector('.domain-search-results')
const domainsOrder = document.querySelector('.domains-order')
const domainsEmptyOrder = document.querySelector('.domain-search-empty')
const domainItemTemplate = document.getElementById('domain_item_template')
const notFreeDomainMessage = document.querySelector("[data-target='domain_search_not_found']")
const cartItemTemplate = document.getElementById('cart_item_template')


if (domainSearchForm) {
    domainSearchForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        this.querySelector('button[type=submit]').classList.add('disabled')
        const formData = new FormData(this);
        const domainInput = cleanDomainInput(formData.get('domain'))
        const submitButton = this.querySelector('button[type=submit]');
        notFreeDomainMessage.classList.remove('opened')
        if (!domainInput) {
            submitButton.classList.remove('disabled')
            addFormError(this)
            return
        }

        formData.append('action', 'checkDomain');
        this.querySelector('input').value = domainInput

        removeFormError(this)
            
        formData.set('domain',domainInput)
        searchResults.innerHTML = ''

        try {
            //Получаем список доменов, для проверки whois
            const result = await getDomainList(formData, 'init');
            
            
            if (result && result.status == 'success') {
                submitButton.classList.remove('disabled');
                searchResults.style.display = 'block';
                
                Object.entries(result.domains).forEach(([domain, domainData]) => {
                    cloneDomainItem(domain, domainData)
                });

                checkAllDomains(result)
                
            } else {
                console.log('erorr', result);
                submitButton.classList.remove('disabled');
                searchResults.style.display = 'none';
                addFormError(this, result?.message);
            }
        } catch (error) {
            submitButton.classList.remove('disabled');
            // searchResults.style.display = 'none';
            console.error('Ошибка при проверке домена:', error);
            addFormError(this, messages.error);
        }
    

    })
}

function cleanDomainInput(input) {
    // Удаляем http://, https:// и www., а также слеш в конце
    let cleanedInput = input
        .replace(/^https?:\/\//i, '') // Удаляем http:// или https://
        .replace(/^www\./i, '')       // Удаляем www.
        .replace(/\/$/, '');          // Удаляем слеш в конце

    return cleanedInput;
}

function addFormError(form,message) {
    // document.getElementById('domain_input_error').textContent = message
    // document.getElementById('domain_input_error').classList.remove('d-none')
    form.classList.add('error')
}
function removeFormError(form) {
    form.classList.remove('error')
}

async function getDomainList(formData, type = 'check') {
    formData.append('type', type);
    try {
        const response = await fetch('/ajax.php', {
            method: 'POST',
            body: formData,
        });
        return await response.json();
    } catch (error) {
        return false
    }
}

async function checkAllDomains(data) { 
    let freeDomains = 0;
    let totalDomains = Object.keys(data.domains).length;
    let processedDomains = 0;
    for (const domain of Object.keys(data.domains)) {
        try {
            const formData = new FormData();
            formData.append('domain', domain);
            formData.append('action', 'checkDomain');
            formData.append('type', 'check');
            formData.append('check_all', data.check_all ? 1 : 0);
            formData.append('free', data.free? 1 : 0);
            
            const response = await fetch('/ajax.php', {
                method: 'POST',
                body: formData
            });

            // Проверяем статус ответа
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            if (updateDomainItem(result)) {
                freeDomains++                
            }
        } catch (error) {
            console.error('Ошибка при проверке домена:', error);
        } finally {
            processedDomains++
             // Проверяем только после обработки всех доменов
             if (processedDomains === totalDomains) {
                if (data.free && freeDomains === 0) {
                    notFreeDomainMessage.classList.add('opened');
                }
            }
        }
    }
}
function cloneDomainItem(domain, domainData) {
    const clone = domainItemTemplate.content.cloneNode(true);
    clone.querySelector("[data-target='domain_item']").setAttribute('data-domain', domain)
    clone.querySelector("[data-target='domain_name']").textContent = domain

    if (domainData.price > 0 && domainData.old_price > 0) {
        const discountPercent = Math.round((1 - domainData.price / domainData.old_price) * 100);
        clone.querySelector("[data-target='domain_discount']").textContent = `-${discountPercent}%`;
    } else {
        clone.querySelector("[data-target='domain_discount']").remove();
    }
    const oldPriceElements = clone.querySelectorAll('[data-target="domain_old_price"]');
    const priceElements = clone.querySelectorAll('[data-target="domain_price"]');
    const domainsInCart = getCookieCart().map(item => item.domain)
    if (domainsInCart.includes(domain)) {
        clone.querySelector("[data-target='domain_action_button']").classList.add('item-added')
    } 
    clone.querySelector("[data-target='domain_action_button']").onclick = function(event) {
        event.preventDefault(); 
        if(addToCookieCart(domain)) {                    
            this.classList.add('item-added')
        } 
    };
    
    if (domainData.price > 0) {
        priceElements.forEach(element => {
            element.textContent = `${domainData.price} ${domainData.symbol}`;
        });
    } else {
        priceElements.forEach(element => {
            element.remove();
        });
    }
    if (domainData.old_price > 0) {
        oldPriceElements.forEach(element => {
            element.textContent = `${domainData.old_price} ${domainData.symbol}`;
        });
    } else {
        oldPriceElements.forEach(element => {
            element.remove();
        });
    }

    if (!domainData.is_free) {
        clone.querySelector("[data-target='domain_is_free']").remove()
    } 
    searchResults.appendChild(clone)
}

function updateDomainItem(data) {
    const domainElement = document.querySelector(`[data-domain="${data.domain}"]`);
    if (!domainElement) return false

    if (data.avail) {
        if (domainElement.querySelector("[data-target='domain_discount']")) {
            domainElement.querySelector("[data-target='domain_discount']").style.display = 'block';
        }
        
        domainElement.querySelectorAll("[data-target='domain_link_whois']").forEach(element => {
            element.remove()
        });
        // domainElement.querySelectorAll("[data-target='domain_link_how']").forEach(element => {
        //     element.remove()
        // });
        domainElement.querySelector("[data-target='domain_status']").textContent = messages.free

        if (domainElement.querySelector("[data-target='domain_is_free']")) {
            domainElement.querySelector("[data-target='domain_is_free']").classList.remove('d-none')
        }
    } else {
        domainElement.classList.add('result-busy')
        domainElement.querySelector("[data-target='domain_status']").textContent = messages.busy
        domainElement.querySelector("[data-target='domain_whios_info']").innerHTML = data.whois
        domainElement.querySelector("[data-target='domain_action_button']").remove()

        const priceElements = domainElement.querySelectorAll('[data-target="domain_price"]')
        const oldPriceElements = domainElement.querySelectorAll('[data-target="domain_old_price"]')
        if (priceElements.length > 0) {
            priceElements.forEach(element => {
                element.remove()
            });
        }
        if (oldPriceElements.length > 0) {
            oldPriceElements.forEach(element => {
                element.remove()
            });
        }

    }

    const loadingElements = domainElement.querySelectorAll('.skeleton-loading')
    if (data.free && !data.avail) {        
        domainElement.style.opacity = 0
        setTimeout(() => {
            domainElement.remove()
        }, 1000)
    }
    if (loadingElements.length > 0) {
        loadingElements.forEach(element => {
            element.classList.remove('skeleton-loading')            
        });        
    }

    return data.avail
}

function toggleWhois(element) {
    const whoisInfo = element.closest("[data-target='domain_item']").querySelector("[data-target='domain_whios_info']");
    whoisInfo.classList.toggle('opened');
}
function getCookieCart() {
    // Считываем текущее значение куки с именем "cart"
    const cartCookie = getCookie('cart');
    let cartData = [];

    // Если куки существуют, попытаемся их разобрать
    if (cartCookie) {
        try {
            cartData = JSON.parse(cartCookie);
        } catch (e) {
            console.error("Ошибка при разборе куки:", e);
        }
    }
    return cartData
}
function addToCookieCart(domain) {
    cartData = getCookieCart()
    const newDomainData = {
        domain: domain,
    };
    // Добавляем новый домен к массиву
    cartData.push(newDomainData);
    
    // Преобразуем обновленный массив обратно в JSON-строку
    const updatedCartJSON = JSON.stringify(cartData);

    // Сохраняем обновленные данные в куки
    setCookie('cart', updatedCartJSON, 365); 

    addToCart(domain)
    return true
}
function removeFromCookieCart(domain) {
    let cartData = getCookieCart()
    cartData = cartData.filter(item => item.domain !== domain)
    // Преобразуем обновленный массив обратно в JSON-строку
    cartData = JSON.stringify(cartData);

    // Сохраняем обновленные данные в куки
    setCookie('cart', cartData, 365); 

    //Включаем кнопку купить
    
    const domainItem = searchResults.querySelector('[data-domain="'+domain+'"]')
    if (domainItem) {
        domainItem.querySelector("[data-target='domain_action_button']").classList.remove('item-added')
    }
    
}
async function getPrice(domain,el, returnData = false) {
    const formData = new FormData();
    formData.append('action', 'getPrice')
    formData.set('domain',domain)
    try {
        const response = await fetch('/ajax.php', {
            method: 'POST',
            body: formData
        });

        // Проверяем успешный ответ
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const data = await response.json();
        if (!returnData) {
            el.innerHTML = data.html;
        } else {
            return data.data
        }
        

    } catch (error) {
        console.error('Error in getPrice:', error);
        return false; // Возвращаем false в случае ошибки
    }
}
async function addToCart(domain) {    
    const clone = cartItemTemplate.content.cloneNode(true);
    const itemData = await getPrice(domain, null, true)
    if (!itemData) {
        return
    }
    clone.querySelector("[data-target='domain_name']").textContent = domain
    clone.querySelector("[data-target='cart_item']").setAttribute('data-domain',domain)
    clone.querySelector("[data-target='domain_remove_btn']").onclick = function(event) {
        removeFromCart(domain)
    };
    
    clone.querySelector("[data-target='domain_price']").textContent = itemData.price + ' ' + itemData.symbol
    
    setTotalCart()
    setCart('full')
    domainsOrder.querySelector('.domains-chosen').appendChild(clone);
}
async function removeFromCart(domain) {
    const item = domainsOrder.querySelector('[data-domain="'+domain+'"]')
    item.remove()
    removeFromCookieCart(domain)
    if (domainsOrder.querySelectorAll('.domains-chosen').length == 0) {
        setCart('empty')
    } else {
        setTotalCart()
    }    
}
async function setTotalCart() {
    const cartData = getCookieCart()
    let totalPrice = 0
    let totalCurrency = ''
    // Используем for...of для асинхронных операций
    for (const item of cartData) {
        const itemData = await getPrice(item.domain, null, true);
        if (itemData) {
            totalPrice += parseFloat(itemData.price);
            totalCurrency = itemData.symbol;
        }
    }
    domainsOrder.querySelector("[data-target='total_price']").textContent = totalPrice + ' ' + totalCurrency
}
function setCart(status) {
    if (status == 'full') {
        domainsOrder.style.display = 'block'
        domainsEmptyOrder.style.display = 'none'     
    } else {
        domainsOrder.style.display = 'none'
        domainsEmptyOrder.style.display = 'block'
    }
}
function initCart() {
    let cartData = getCookieCart()
    
    if (cartData.length > 0) {
        cartData.forEach(item=> {
            addToCart(item.domain)
        })
    } else {
        setCart('empty')
    }    
}
initCart()
